// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1485":"7d26c145","2826":"7d26c145","9753":"7d26c145"}[chunkId] + ".chunk.css";
};